// extracted by mini-css-extract-plugin
module.exports = {"over":"style_over__9QGJc","container":"style_container__37X2D","btnClose":"style_btnClose__3rp36"};